module.exports = __webpack_public_path__ + "img/banner.1c064203.png";